import React from 'react'
import '../Styles/TeenCampPage2.scss';
import speakerImage1 from "../Images/140308_Stump,_Levi_U3.png";
import speakerImage2 from "../Images/136353_Palchevskiy,_Jonathan_U3_1.png";
import speakerImage3 from "../Images/144160____Patton,_Isaac_U_(1).png"

function DeafCampPage2() {
   return(
      <div className="teenCampPage2Content">
         <div className="teenCampPage2Container">
            <div className="teenCampPage2Title">
                  2023 Teen Camp Speakers
            </div>
            <div className="teenCampPage2SpeakerPictures">
               <div className="teenPictureAndText1">
                  <div className='speakerPicture1'>
                     <img className="teenPic1" src={speakerImage1} alt="SpeakerImage1"></img>
                  </div>
                  <div className="speakerName1">
                     Week 1 <br></br>
                     Levi Stump
                  </div>
               </div>

               <div className="teenLineContainer">
                  <div className="teenvl"></div>
               </div>
               
               <div className="teenPictureAndText2">
                  <div className='speakerPicture2'>
                     < img className="teenPic2" src={speakerImage2} alt="SpeakerImage2"></img>
                  </div>
                  <div className="speakerName2">
                     Week 2 <br></br>
                     Jonathan Palchevskiy
                  </div>
               </div>

               <div className="teenLineContainer">
                  <div className="teenvl"></div>
               </div>

               <div className="teenPictureAndText3">
                  <div className='speakerPicture2'>
                     < img className="teenPic2" src={speakerImage3} alt="SpeakerImage2"></img>
                  </div>
                  <div className="speakerName2">
                     Week 2 <br></br>
                     Isaac Patton
                  </div>
               </div>

            </div>
         </div>
      </div>
   )
}
export default DeafCampPage2;